export default __webpack_public_path__ + "static/media/CRDoubleToroClosed.be1b4c5d.jpg";